import { createStepRegistry } from "../../utils/flowAnalytics/createStepRegistry.js";
import { normalizeEntryFlowSlug, normalizeFlowSlug } from "../../utils/flowAnalytics/flowSlug.js";
import GeneralError from "../../searchFlowVersionB/steps/common/GeneralError.jsx";
import RegActivityDescription from "../steps/RegActivityDescription.jsx";
import RegCompanyType from "../steps/RegCompanyType.jsx";
import RegContactPage from "../steps/RegContactPage.jsx";
import RegForeignTrade from "../steps/RegForeignTrade.jsx";
import RegIndustryActivity from "../steps/RegIndustryActivity.jsx";
import RegIndustrySelect from "../steps/RegIndustrySelect.jsx";
import RegSuccessScreen from "../steps/RegSuccessScreen.jsx";
import RegTaxForm from "../steps/RegTaxForm.jsx";

/**
 * Stable step metadata keyed by React component.
 * stepId values are persisted in MongoDB — do not rename; add new entries for new steps.
 */
const STEP_META_BY_COMPONENT = new Map([
  [RegIndustrySelect, { id: "reg_industry_select", phase: "reg" }],
  [RegIndustryActivity, { id: "reg_industry_activity", phase: "reg" }],
  [RegCompanyType, { id: "reg_company_type", phase: "reg" }],
  [RegActivityDescription, { id: "reg_activity_description", phase: "reg" }],
  [RegTaxForm, { id: "reg_tax_form", phase: "reg" }],
  [RegForeignTrade, { id: "reg_foreign_trade", phase: "reg" }],
  [RegContactPage, { id: "reg_contact_page", phase: "reg" }],
  [RegSuccessScreen, { id: "reg_success_screen", phase: "reg" }],
  [GeneralError, { id: "reg_general_error", phase: "reg" }],
]);

/**
 * Context fields owned by each step — only these are sent on events for that step.
 * Persisted in MongoDB; add keys here when a step collects new analytics dimensions.
 */
export const STEP_CONTEXT_FIELDS = {
  reg_industry_select: ["industry", "companytype"],
  reg_industry_activity: ["industry", "companytype"],
  reg_company_type: ["regCompanyTypeSelection", "regEntrySource"],
};

const regFlowStepRegistry = createStepRegistry({
  metaByComponent: STEP_META_BY_COMPONENT,
  contextFieldsByStepId: STEP_CONTEXT_FIELDS,
});

export const { getStepMeta, getStepMetaAtIndex, getStepContextFieldKeys } =
  regFlowStepRegistry;

export default regFlowStepRegistry;

export { normalizeEntryFlowSlug, normalizeFlowSlug };
